<div *ngIf="_workflowService.isWorkflowProcessTabOpened" class="own-p-sidebar own-p-sidebar-right">
  <div class="p-sidebar-header ml-auto">
    <p-button
      type="button"
      (click)="_workflowService.isWorkflowProcessTabOpened = false"
      icon="pi pi-times"
      styleClass="p-button-sm p-0 ml-auto border-none">
    </p-button>
  </div>
  <div class="p-sidebar-content">
    <div class="d-flex flex-row">
      <div class="content-left mr-3" *ngIf="processHistoryList?.length > 0">
        <div class="position-relative mt-3 mb-4">
          <div class="btnCloseFlow">
            <i class="fa fa-times f-18" aria-hidden="true" (click)="processHistoryList = []"></i>
          </div>
        </div>
        <div class="position-relative">
          <div class="s-custom-entity-records scrolled" (scroll)="onProcess_Scroll($event)" #process_ScrollableElement>
            <i class="pi pi-arrow-up" (click)="process_ScrollToTop()" *ngIf="process_scrollTop > 50"></i>
            <p-table [value]="processHistoryList" [tableStyle]="{ 'min-width': '50rem' }" [paginator]="false" [rows]="10">
              <ng-template pTemplate="header">
                <tr>
                  <th>Name</th>
                  <th>Status</th>
                  <th>Created</th>
                </tr>
              </ng-template>
              <ng-template pTemplate="body" let-process_history>
                <tr class="cursor-pointer" (click)="LoadWorkflowHandler(process_history); processHistoryList = []">
                  <td>{{ activatedHistoryName || '' }}</td>
                  <td>{{ process_history?.status }}</td>
                  <td>{{ process_history.created_at | customTimeAgo }}</td>
                </tr>
              </ng-template>
            </p-table>
          </div>
        </div>
        <div class="mt-3">
          <p *ngIf="processHistoryList?.length > 0">
            {{ 'Records: ' + pagination?.total }}
          </p>
        </div>
      </div>
      <div class="content-right" [ngClass]="{ 'w-100': processHistoryList?.length === 0 }">
        <ul class="nav nav-tabs" role="tablist">
          <li class="nav-item w-4" role="presentation">
            <button
              class="nav-link active w-100"
              id="progress-tab"
              data-bs-toggle="tab"
              data-bs-target="#status_progress"
              type="button"
              role="tab"
              aria-controls="status_progress"
              aria-selected="true"
              (click)="_workflowService.isLoad = true; onWorkflowChangeTab('progress')">
              In Progress
            </button>
          </li>
          <li class="nav-item w-4" role="presentation">
            <button
              class="nav-link w-100"
              id="completed-tab"
              data-bs-toggle="tab"
              data-bs-target="#status_completed"
              type="button"
              role="tab"
              aria-controls="status_completed"
              aria-selected="false"
              (click)="_workflowService.isLoad = true; onWorkflowChangeTab('completed')">
              Completed
            </button>
          </li>
          <li class="nav-item w-4" role="presentation">
            <button
              class="nav-link w-100"
              id="paused-tab"
              data-bs-toggle="tab"
              data-bs-target="#status_paused"
              type="button"
              role="tab"
              aria-controls="status_paused"
              aria-selected="false"
              (click)="_workflowService.isLoad = true; onWorkflowChangeTab('paused')">
              Paused
            </button>
          </li>
        </ul>
        <div class="position-relative mt-3 mb-4">
          <i class="pi pi-search search-Icon"></i>
          <input
            type="text"
            [(ngModel)]="search_keyword"
            (input)="FilterSearchProcessList($event?.target?.value)"
            placeholder="Search Process"
            class="search-Input" />
        </div>
        <div class="form-group" *ngIf="activeTabName !== 'completed'">
          <label class="">Start / Paused</label>
          <div class="SP-switch">
            <p-inputSwitch [(ngModel)]="_workflowService.module_isStop" (onChange)="changeStatus()"></p-inputSwitch>
          </div>
        </div>
        <ng-container *ngIf="_workflowService.ActiveProcessList?.length > 0; else notFound">
          <div class="position-relative">
            <div class="s-custom-entity-records scrolled" (scroll)="onScroll($event)" #scrollableElement>
              <i class="pi pi-arrow-up" (click)="scrollToTop()" *ngIf="scrollTop > 50"></i>
              <div *ngFor="let process of _workflowService.ActiveProcessList; let i = index" class="blockElement noSelect w-auto">
                <div class="blockIn ml-0 no-wrap-block justify-content-between align-items-center position-relative">
                  <div class="d-flex flex-row align-items-center">
                    <div class="blockIcon cursor-pointer" (click)="ChangeProcessStatus(process)">
                      <img [src]="common_images?.play_icon" width="24" height="24" *ngIf="GetProcessesStatus(process?.filter) === 'play'" />
                      <img [src]="images?.pause_icon_v2" width="24" height="24" *ngIf="GetProcessesStatus(process?.filter) === 'pause'" />
                      <img [src]="common_images?.pause_icon" width="24" height="24" *ngIf="GetProcessesStatus(process?.filter) === 'stop'" />
                    </div>
                    <div class="blockText cursor-default" (click)="showProcessWorkflow(process)">
                      <p class="blockTitle mb-1">{{ process?.tigger_title }}</p>
                      <p-badge [value]="process?.module" styleClass="mr-2 ml-auto rounded"></p-badge>
                    </div>
                  </div>
                  <img [src]="images?.progress_icon" width="30" height="30" (click)="ViewProcessHistory(process?._id)" class="cursor-pointer" />
                  <p
                    class="process-count cursor-pointer"
                    [ngStyle]="{ right: process?.process_running_count?.toString()?.length > 1 ? '8px' : '12px' }"
                    (click)="ViewProcessHistory(process?._id)">
                    {{ process?.process_running_count }}
                  </p>
                </div>
              </div>
            </div>
          </div>
          <div class="mt-3">
            <p *ngIf="_workflowService.ActiveProcessList?.length > 0">
              {{ 'Records: ' + _workflowService.centralizedProcessPagination?.total }}
            </p>
          </div>
        </ng-container>
        <ng-template #notFound>
          <p>{{ _workflowService?.isLoad == true ? 'Loading' : 'No record found' }}</p>
        </ng-template>
      </div>
    </div>
  </div>
</div>
